import React from 'react';
import { Link } from 'react-router-dom';
import './Datenshutz.css';
import Navbar from './Navbar';
import Footer from './Footer';

const Datenschutz = () => {
    return (
        <div className="datenschutz-page">
            <Navbar />

            <section className="datenschutz-hero">
                <div className="datenschutz-hero-content">
                    <h1 className="datenschutz-heading">Datenschutzerklärung</h1>
                    <p className="datenschutz-subtitle">Informationen zum Umgang mit Ihren Daten</p>
                </div>
            </section>

            <section className="datenschutz-main">
                <div className="datenschutz-container">

                    <div className="datenschutz-section">
                        <h2>1. Verantwortlicher</h2>
                        <p>
                            Lucky Garden<br />
                            Straubinger Straße 22<br />
                            4600 Wels, Österreich<br />
                            E-Mail: <a href="mailto:info@luckygarden.at">info@luckygarden.at</a><br />
                            Telefon: <a href="tel:+43123456789">+43 123 456 789</a>
                        </p>
                    </div>

                    <div className="datenschutz-section">
                        <h2>2. Allgemeines zur Datenverarbeitung</h2>
                        <p>
                            Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Diese Website erhebt und verarbeitet
                            grundsätzlich keine personenbezogenen Daten. Es werden keine Cookies gesetzt, kein
                            Nutzertracking durchgeführt und keine Anmeldefunktionen oder Formulare verwendet, die
                            personenbezogene Daten speichern.
                        </p>
                    </div>

                    <div className="datenschutz-section">
                        <h2>3. Hosting</h2>
                        <p>
                            Diese Website wird über <strong>Vercel Inc.</strong> (340 Pine Street, Suite 701, San Francisco,
                            CA 94104, USA) gehostet. Beim Aufruf der Website werden automatisch technische Daten
                            (z. B. IP-Adresse, Browsertyp, Uhrzeit des Zugriffs) in Server-Logfiles gespeichert.
                            Diese Daten werden ausschließlich für den technischen Betrieb der Website verwendet und
                            nicht an Dritte weitergegeben. Weitere Informationen finden Sie in der
                            Datenschutzerklärung von Vercel:{' '}
                            <a href="https://vercel.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer">
                                vercel.com/legal/privacy-policy
                            </a>.
                        </p>
                    </div>

                    <div className="datenschutz-section">
                        <h2>4. Cookies</h2>
                        <p>
                            Diese Website verwendet <strong>keine Cookies</strong>. Es werden weder eigene noch
                            Drittanbieter-Cookies gesetzt.
                        </p>
                    </div>

                    <div className="datenschutz-section">
                        <h2>5. Kontaktaufnahme per E-Mail oder Telefon</h2>
                        <p>
                            Wenn Sie uns per E-Mail oder Telefon kontaktieren, werden die von Ihnen übermittelten Daten
                            (z. B. Name, E-Mail-Adresse, Nachrichteninhalt) ausschließlich zur Bearbeitung Ihrer Anfrage
                            verwendet. Eine Weitergabe an Dritte erfolgt nicht. Die Daten werden nach Abschluss der
                            Bearbeitung gelöscht, sofern keine gesetzlichen Aufbewahrungspflichten bestehen.
                        </p>
                        <p>
                            Rechtsgrundlage für die Verarbeitung ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse
                            an der Beantwortung von Anfragen).
                        </p>
                    </div>

                    <div className="datenschutz-section">
                        <h2>6. Ihre Rechte</h2>
                        <p>Sie haben jederzeit das Recht auf:</p>
                        <ul>
                            <li>Auskunft über Ihre bei uns gespeicherten Daten (Art. 15 DSGVO)</li>
                            <li>Berichtigung unrichtiger Daten (Art. 16 DSGVO)</li>
                            <li>Löschung Ihrer Daten (Art. 17 DSGVO)</li>
                            <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
                            <li>Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
                            <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
                        </ul>
                        <p>
                            Zur Ausübung Ihrer Rechte wenden Sie sich bitte an:{' '}
                            <a href="mailto:info@luckygarden.at">info@luckygarden.at</a>
                        </p>
                        <p>
                            Zudem haben Sie das Recht, sich bei der zuständigen Datenschutzbehörde zu beschweren.
                            In Österreich ist dies die <strong>Datenschutzbehörde</strong> (
                            <a href="https://www.dsb.gv.at" target="_blank" rel="noopener noreferrer">www.dsb.gv.at</a>).
                        </p>
                    </div>

                    <div className="datenschutz-section">
                        <h2>7. Aktualität dieser Datenschutzerklärung</h2>
                        <p>
                            Diese Datenschutzerklärung ist aktuell gültig und hat den Stand April 2026.
                            Wir behalten uns vor, diese Erklärung bei Bedarf anzupassen.
                        </p>
                    </div>

                    <div className="datenschutz-back">
                        <Link to="/" className="datenschutz-back-btn">← Zurück zur Startseite</Link>
                    </div>

                </div>
            </section>

            <Footer />
        </div>
    );
};

export default Datenschutz;
